import { Component, OnInit } from '@angular/core';
import { NotifierService } from 'angular-notifier';
import { ExcelViewerService } from '../../service/excel-viewer.service';
import { RepoApiService } from '../../service/repo-api.service';
import { ReportService } from '../../service/report.service';
import { ToplineService } from '../../service/topline.service';
@Component({
  selector: 'app-edit-sheet',
  templateUrl: './edit-sheet.component.html',
  styleUrls: ['./edit-sheet.component.scss']
})
export class EditSheetComponent implements OnInit {
  public topcutContainerForEditSheet:any [] = [];
  public selectedTopcuts :any = {}
  public editSheetRename:boolean = false;
  constructor(
    public eService:ExcelViewerService,
    public toplineService:ToplineService,
    public reportService:ReportService,
    private repoService:RepoApiService,
    private notifier:NotifierService
  ) { }

  ngOnInit(): void {
    this.eService.getSheetPayload()
  }



  EditSheetRenameFunction(){
    this.eService.selectedSheetName = JSON.parse(JSON.stringify(this.eService.selectedSheet.value.sheet_name));
    this.editSheetRename = true;
  }


  editSheetNameFouseOut(){
    // this.evService.renameSheet();
    if (this.eService.selectedSheetName === this.eService.selectedSheet.value.sheet_name) {
      this.eService.isSheetnameEdit = false;
    }else{
      this.eService.selectedSheet.value["new_sheet_name"] = this.eService.selectedSheetName 
      this.eService.renameSheet();
      this.editSheetRename = false;
    }

  }

  getSelectedParent(topcuts, selectedTopcutOption){
    let parents = [];
    selectedTopcutOption.forEach(option => {
      parents.push(option.p)
    });
    parents = parents.filter(
      (element, i) => i === parents.indexOf(element)
    )
    return parents;
  }


  onSave(){
    this.eService.table_definition = {'topcut':[],'table':[]}
    let body = {
      payload:{
        topcut:{"value_type":"","values":{}},
        selected_tables:[]
      },
      table_definition:{"topcut":[]},
      cross_tab_id:"",
      file_id:"",
      sheet_id:this.eService.selectedSheet.value.sheet_id,
    };
    body['payload']["topcut"]["value_type"] = this.eService.currentSheetTopcuts[0]["value_type"];
    body['payload']["selected_tables"] = this.eService.currentSheetTopcuts[0]["selected_tables"];
    body["cross_tab_id"] = this.toplineService.crosstab_fileUUID;
    body["file_id"] = this.toplineService.excelviewer_fileUUID;
    if (this.eService.currentSheetTopcuts[0]["value_type"] == "topcut") {
      body['payload']["topcut"]["values"] = this.eService.getTreeFormat(this.eService.currentSheetTopcuts[0]["topcut"],'topcut')
    }else{
      // if (this.eService.currentSheetTopcuts[0]["value_type"] == "table") {
      //   let selectedTables = this.eService.currentSheetTopcuts[0]["topcut"].map(table => table.uuid);
      //   body['payload']["selected_tables"] = [...body['payload']["selected_tables"], ...selectedTables];
      // }
      this.eService.currentSheetTopcuts[0]["topcut"].forEach(tCut => {
        body["payload"]["topcut"]["values"][tCut.uuid] = tCut
        if (this.eService.currentSheetTopcuts[0]["value_type"] == "table") {
          body['payload']["selected_tables"].push(tCut.uuid);
          this.eService.addToTableDefinition(tCut.uuid,"topcut")
        }
      });
    }
    body['table_definition']["topcut"] = this.eService.table_definition['topcut']
    // console.log("body editSheetSubmit =====> ",body);
    this.editSheetSubmit(body)
  }

  editSheetSubmit(body){
    this.repoService.editSheetTopCut(body).subscribe(
      result =>{
        if (result["status"] == 1) {
          this.notifier.notify("success","Sheet uptated successfully");
          this.eService.table_definition = {'topcut':[],'table':[]}
          this.eService.closeEditSheetComponent();
          this.eService.refreshFilterOptions();
        }else{
          this.notifier.notify("error","Something went wrong!")
        }
      }
    )
  }

  returnDataTreeItems(datatype:string,topcuts){
    let tempObj = this.toplineService.sortTreeItem(this.toplineService.toplineTreeItems[datatype],datatype,topcuts);
    return tempObj.tree;
  }

}
